exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".content[data-v-4baea3dc]{background-color:#f0f6f9;padding-bottom:.3rem}.title[data-v-4baea3dc]{width:12rem;height:.6rem;color:#000;font-size:.15rem;font-weight:400;font-family:Alibaba PuHuiTi;display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;margin-left:3.6rem}.title span[data-v-4baea3dc]:first-child{color:#ccc}.del_left[data-v-4baea3dc]{width:11.4rem;background:#fff;padding:.3rem;border-radius:.04rem;box-shadow:0 0 .14rem 0 #134f9721;margin:0 auto}.left_top[data-v-4baea3dc]{border-bottom:1px solid #eee}.del_title[data-v-4baea3dc]{font-size:.24rem;color:#000;margin-bottom:.09rem;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.del_time[data-v-4baea3dc],.del_title[data-v-4baea3dc]{font-family:Alibaba PuHuiTi;font-weight:500;text-align:center}.del_time[data-v-4baea3dc]{font-size:.14rem;color:#ccc;margin-bottom:.17rem}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-4baea3dc","scoped":true,"hasInlineConfig":false}!./~/less-loader/dist/cjs.js!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/index/textDetail.vue
// module id = 228
// module chunks = 0